import React from "react";
import cn from "classnames";
import styles from "./Social.module.sass";
import Icon from "../../../components/Icon";

const socials = [
    {
        title: "Etherscan Profile",
        icon: "/images/icons/etherscan.png",
        url: "https://etherscan.io/address/0x641ad78baca220c5bd28b51ce8e0f495e85fe689",
    },
    /*{
        title: "OpenSea Profile",
        icon: "/images/icons/ens.png",
        url: "...",
    },
    {
        title: "ENS Profile",
        icon: "/images/icons/opensea.png",
        url: "...",
    },*/
];

const Social = () => {
    return (
        <div className={styles.profile}>
            <div className={styles.details}>
                <div className={styles.avatar}>
                    <img src="/images/content/avatar.jpg" alt="Avatar" />
                    <button className={styles.add}>
                        <Icon name="add" />
                    </button>
                </div>
                <div className={styles.wrap}>
                    <div className={cn("h4", styles.man)}>
                        vitally.eth
                    </div>
                    <div className={styles.info}>
                        0x23423...234242
                    </div>
                </div>
            </div>
            <div className={styles.contacts}>
                <div className={styles.socials}>
                    {socials.map((x, index) => (
                        <a
                            className={styles.social}
                            href={x.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={index}
                        >
                            <img src={x.icon} alt="Avatar" />
                        </a>
                    ))}
                </div>
                <button className={cn("button", styles.button)}>
                    LiquidNFTs Profile
                </button>
            </div>
        </div>
    );
};

export default Social;
